import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import styles from './page-header-nav.less';

const PageHeaderNavLink = ({ to, label, onClick }) => (
  <div className={styles.PageHeaderNav}>
    <Link to={to} onClick={onClick}>
      &lt; {label}
    </Link>
  </div>
);

PageHeaderNavLink.propTypes = {
  to: PropTypes.shape({}).isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

PageHeaderNavLink.defaultProps = {
  onClick: undefined,
};

export default withRouter(PageHeaderNavLink);
